import * as React from 'react';
import classNames from 'classnames';
import './SubNav.scss';
import { ISubNavProps, IMenuItem } from './types';
import { Link } from 'react-router-dom';
import Icon from '../Icon';

const renderDropdown = (items: IMenuItem[], isLast: boolean) => (
  <ul className={classNames('global-header__sub-dropdown', isLast && 'is-last')}>
    {items.map((item: IMenuItem, index: number) => (
      <li key={index}>
        <Link to={item.path}>{item.label}</Link>
      </li>
    ))}
  </ul>
);

const SubNav = ({ menuItems }: ISubNavProps) => (
  <ul className="global-header__sub-nav">
    {menuItems.map((item: IMenuItem, index: number) =>
      <li
        key={item.path}
        className={classNames({
          'is-active': location.pathname.indexOf(item.path) !== -1,
          'has-children': item.children.length > 0
        })}
      >
        <Link to={item.path}>
          {item.label || ''}
          {item.icon !== undefined && (
            <Icon name={item.icon} className="w-3 h-3 mx-1" />
          )}
        </Link>
        {item.children.length > 0 && (
          <Icon name="chevron-down" className="dropdown-icon ml1" />
        )}
        {item.children.length > 0 && renderDropdown(item.children, index + 1 >= menuItems.length)}
      </li>
    )}
  </ul>
)

export default SubNav



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/SubNav.tsx